import type { Variants } from "motion/react";

export const slideVariants: Variants = {
	enter: (direction: number) => ({
		x: direction > 0 ? 80 : -80,
		opacity: 0,
	}),
	center: {
		x: 0,
		opacity: 1,
	},
	exit: (direction: number) => ({
		x: direction > 0 ? -80 : 80,
		opacity: 0,
	}),
};

export const slideTransition = {
	duration: 0.15,
	ease: "easeOut" as const,
};
